
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manage-cookies",
      function () {
        return require("private-next-pages/manage-cookies.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manage-cookies"])
      });
    }
  